export enum MaterialType {
    ANIMAL = 'Animal',
    SAMPLE = 'Sample'
}